var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$store.state.isPc?"pc_userList":"md_userList"},_vm._l((_vm.list),function(v,i){return _c('div',{key:i},[_c('img',{attrs:{"src":v.avatar}}),_c('p',[_vm._v(_vm._s(v.user_name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }